import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

const STATUSES = {
  active: { color: "success", label: "Active" },
  archived: { color: "error", label: "Archived" },
  draft: { color: "gray", label: "Draft" },
};

const FormStatusBadge = ({ status }) => {
  const { color, label } = STATUSES[status] || STATUSES.draft;
  return <Badge color={color} dot>{label}</Badge>;
};

FormStatusBadge.propTypes = {
  status: PropTypes.string,
};

export default FormStatusBadge;
